import PropTypes from 'prop-types';
import React from 'react';
import GS from '../grafsync/grafsync';
import Errored from './Errored';
import MenuSelector from './MenuSelector';
import { makeCancelable } from './utils/utils';

class SubscriptionUsers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: "All",
            users: [],
            sortedUsers: [],
        };
        this.cancellable2 = null;
    }

    componentDidMount() {
        this.getUsers();
    }

    componentWillUnmount() {
        if (this.cancellable2) this.cancellable2.cancel();
    }

    getUsers = async () => {
        this.setState(
            { isLoadingUsers: true },
            () => {
                this.doGetUsers()
                    .promise
                    .then(data => {
                        if (this.cancellable2 && this.cancellable2.isCancelled()) return;
                        if (data) {
                            const sortedUsers = data.map(user => ({
                                value: user.id,
                                label: user.givenName && user.familyName ?
                                    user.givenName + " " + user.familyName
                                    :
                                    user.username
                            }))
                                .sort(function (a, b) {
                                    return a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 1;
                                });
                            this.setState({ users: data, sortedUsers, isLoadingUsers: false });
                        }
                        else {
                            this.setState({ isLoading: false });
                        }
                    })
                    .catch((e) => {
                        if (this.cancellable2 && !this.cancellable2.isCancelled()) this.setState({ isErrored: e });
                    });
            });
    };

    doGetUsers() {
        this.cancellable2 = makeCancelable(GS.subscriptionUsers(this.props.projectIRI));
        return this.cancellable2;
    }

    handleUserChange = (user) => {
        this.setState({ user }, () => this.props.onUserChange(user));
    };

    render() {

        const { isErrored, sortedUsers } = this.state;
        const { includeLabel, allLabel } = this.props;

        if (isErrored) return <Errored data={isErrored} />;

        return (
            <MenuSelector
                dataTest="user-selector"
                label={includeLabel ? "User" : null}
                selected="All"
                handleChange={this.handleUserChange}
                hintWord="user"
                options={[
                    {
                        "value": "All",
                        "label": allLabel
                    },
                    ...sortedUsers
                ]} />

        );
    }
}

SubscriptionUsers.defaultProps = {
    includeLabel: true,
    allLabel: "All"
};

SubscriptionUsers.propTypes = {
    includeLabel: PropTypes.bool,
    allLabel: PropTypes.string,
    onUserChange: PropTypes.func.isRequired,
    projectIRI: PropTypes.string
};

export default SubscriptionUsers;